<template>
  <el-option :value="value" :label="label" :disabled="disabled" :created="created">
    <slot></slot>
  </el-option>
</template>
<script>
export default {
  name: 'SuiOption',
  props: {
    value: {
      type: [String, Number, Object]
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    created: {
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SimbartUI/components/form/SuiOption.vue